<template>
  <b-sidebar
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="reset"
    @change="$emit('update:is-sidebar-active', $event)"
  >
    <div
      class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
    >
      <h5 class="mb-0">
        {{
          `${isAdd ? $t("actions.add") : $t("actions.edit")} ${$tc(
            "hanwha_alarm_profile.title",
            1
          )}`
        }}
      </h5>
      <feather-icon
        icon="XIcon"
        class="cursor-pointer"
        @click="$emit('update:is-sidebar-active', false)"
      />
    </div>
    <validation-observer ref="observer" #default="{ handleSubmit }">
      <b-form class="p-2" @submit.prevent="handleSubmit(submit)">
        <validation-provider #default="ctx" name="tenant" rules="required">
          <b-form-group label="Tenant" :state="state(ctx)">
            <v-select
              v-model="form.id_tenant"
              :options="tenantOptions"
              :reduce="(item) => item.value"
              :clearable="false"
              :disabled="!isAdd"
            />
            <b-form-invalid-feedback :state="state(ctx)">{{
              ctx.errors[0]
            }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider #default="ctx" name="name" rules="required">
          <b-form-group :label="$t('hanwha_alarm_profile.name')">
            <b-form-input v-model.trim="form.name" :state="state(ctx)" />
            <b-form-invalid-feedback>{{ ctx.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <b-form-group :label="$t('hanwha_alarm_profile.description')">
          <b-form-textarea v-model.trim="form.description" rows="3" />
        </b-form-group>
        <b-form-checkbox v-model="form.enabled" switch>{{
          $t("hanwha_alarm_profile.enabled")
        }}</b-form-checkbox>
        <div class="d-flex mt-2">
          <b-button type="submit" variant="primary" class="mr-1" :disabled="saving">{{
            $t("actions.save")
          }}</b-button>
          <b-button
            variant="outline-secondary"
            @click="$emit('update:is-sidebar-active', false)"
            >{{ $t("actions.cancel") }}</b-button
          >
        </div>
      </b-form>
    </validation-observer>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";

const blank = () => ({
  id: null,
  id_tenant: null,
  name: "",
  description: "",
  enabled: true,
});

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormInvalidFeedback,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  props: {
    isSidebarActive: Boolean,
    isAdd: Boolean,
    itemEdit: Object,
    tenantOptions: Array,
  },
  data: () => ({ required, form: blank(), saving: false }),
  watch: {
    isSidebarActive(active) {
      if (active) this.form = this.isAdd ? blank() : { ...blank(), ...this.itemEdit };
    },
  },
  methods: {
    state(ctx) {
      return ctx.dirty || ctx.validated ? !ctx.errors.length : null;
    },
    reset() {
      this.form = blank();
      this.$refs.observer?.reset();
    },
    async submit() {
      this.saving = true;
      try {
        const response = this.isAdd
          ? await store.dispatch("hanwha_alarm_profiles/add", this.form)
          : await store.dispatch("hanwha_alarm_profiles/edit", {
              id: this.form.id,
              params: this.form,
            });
        this.$toast({
          component: ToastificationContent,
          props: { title: response.message, icon: "CheckIcon", variant: "success" },
        });
        this.$emit("saved");
        this.$emit("update:is-sidebar-active", false);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.response?.data?.message || error.message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

